import * as Yup from "yup";

const validationSchema = (schema: any) => {
  const valid = Yup.object({
    parking: Yup.string()
  });
  return valid;
};

export default validationSchema;
